const loadBrowserState = (stateName) => {
  // console.debug('localState(), stateName = ', stateName);
  try {
    const serializedState = localStorage.getItem(stateName);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};
const saveBrowserState = (stateName, stateValue) => {
  // console.debug('saveBrowserState(): ', { stateName, stateValue });
  try {
    const serializedState = JSON.stringify(stateValue);
    localStorage.setItem(stateName, serializedState);
  } catch (err) {
    // Ignore write errors;
    console.debug('Failed to save state to local storage', err);
  }
};

const getUserDisplayName = (id) => {
  if (!id) {
    return '';
  }

  const userMappings = localStorage.getItem('userMapping')
    ? JSON.parse(localStorage.getItem('userMapping'))
    : [];

  const filteredUser = userMappings.find((t) => t.id === id);
  return filteredUser ? filteredUser.name : '';
};

module.exports = {
  loadBrowserState,
  saveBrowserState,
  getUserDisplayName
};

// const loadState = () => {
//   console.debug('localState()');
//   try {
//     const serializedState = localStorage.getItem('state');
//     if (serializedState === null) {
//       return undefined;
//     }
//     return JSON.parse(serializedState);
//   } catch (e) {
//     return undefined;
//   }
// };

// const saveState = (state) => {
//   console.debug('saveState: state = ', state);
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem('state', serializedState);
//   } catch (e) {
//     // Ignore write errors;
//   }
// };

// const peristedState = loadState();

// store.subscribe(() => {
//   saveState(store.getState());
// });

// const store = createStore(
//   persistedState,
//   // Others reducers...
// );

// render(
//   <Provider store={store}>
//     <App/>
//   </Provider>,
//   document.getElementById('root');
// );

// Serialization is an expensive operation. You should use a throttle function (like the one implemented by lodash) to limit the number of saves.
// Eg:

// import throttle from 'lodash/throttle';

// store.subscribe(throttle(() => {
//   saveState(store.getState());
// }, 1000));
